import { Node_Type } from "./../../ricos-schema/legacy/wix/rich_content/v1/index.js";
const isContentStateEmpty = (contentState) => {
  const { blocks } = contentState;
  if (blocks.length === 0) {
    return true;
  }
  if (blocks.length > 1) {
    return false;
  }
  const firstBlock = blocks[0];
  const { text, type, depth } = firstBlock;
  return text === "" && type === "unstyled" && depth === 0;
};
const isRichContentEmpty = (contentState) => {
  if (contentState.nodes?.length === 0) {
    return true;
  } else if ((contentState.nodes?.length ?? 0) > 1) {
    return false;
  } else {
    const firstNode = contentState.nodes?.[0];
    const { nodes, type, paragraphData } = firstNode;
    return nodes?.length === 0 && type === Node_Type.PARAGRAPH && [void 0, 0].includes(paragraphData?.indentation);
  }
};
export {
  isContentStateEmpty,
  isRichContentEmpty
};
//# sourceMappingURL=contentStateUtils.js.map
